module.exports = __webpack_public_path__ + "img/followers.b0b6d4fd.svg";